export { default as ConfigForm } from "./ConfigForm.svelte";
